var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { eager: "", width: "500" },
      model: {
        value: _vm.openDialog,
        callback: function($$v) {
          _vm.openDialog = $$v
        },
        expression: "openDialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            { attrs: { color: "green", dark: "", dense: "", flat: "" } },
            [_c("span", [_vm._v("Create Detail")])]
          ),
          _c(
            "v-container",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Balance",
                          readonly: "",
                          value: _vm.balance.phpFormat()
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Account Code",
                          loading: !_vm.accountCodes.length,
                          items: _vm.accountCodes,
                          "item-value": "account_code.id",
                          "item-text": "account_code.account_code"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "selection",
                            fn: function({ item }) {
                              return [
                                _c(
                                  "span",
                                  { staticClass: "primary--text mr-2" },
                                  [
                                    _vm._v(
                                      _vm._s(item.account_code.account_code)
                                    )
                                  ]
                                ),
                                _c(
                                  "small",
                                  { staticClass: "blue-grey--text" },
                                  [
                                    _vm._v(
                                      _vm._s(item.account_code.description)
                                    )
                                  ]
                                )
                              ]
                            }
                          },
                          {
                            key: "item",
                            fn: function({ item }) {
                              return [
                                _c(
                                  "span",
                                  { staticClass: "primary--text mr-2" },
                                  [
                                    _vm._v(
                                      _vm._s(item.account_code.account_code)
                                    )
                                  ]
                                ),
                                _c(
                                  "small",
                                  { staticClass: "blue-grey--text" },
                                  [
                                    _vm._v(
                                      _vm._s(item.account_code.description)
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.accountCodeId,
                          callback: function($$v) {
                            _vm.accountCodeId = $$v
                          },
                          expression: "accountCodeId"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Amount" },
                        model: {
                          value: _vm.amount,
                          callback: function($$v) {
                            _vm.amount = $$v
                          },
                          expression: "amount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Description" },
                        model: {
                          value: _vm.description,
                          callback: function($$v) {
                            _vm.description = $$v
                          },
                          expression: "description"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            dark: "",
                            small: "",
                            color: "green",
                            dense: "",
                            block: "",
                            loading: _vm.ptCashVoucherDetailStorePosting
                          },
                          on: { click: _vm.store }
                        },
                        [_c("span", [_vm._v("Store")])]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            dark: "",
                            small: "",
                            block: "",
                            color: "error",
                            dense: ""
                          },
                          on: {
                            click: function($event) {
                              _vm.openDialog = false
                            }
                          }
                        },
                        [_c("span", [_vm._v("Cancel")])]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }